import React from "react";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { NSBoxBoolean } from "./NSBoxBoolean";
import { NSBox } from "./NSBox";

export interface NSBoxBooleansProps extends IBaseComponentProps
{
	items: {
		value: string,
		text: string
	}[];
	reverse?: boolean;
	onChanged?: (e: NSBoxBooleans, callback?: () => void) => void;
	box_all?: IBaseComponentProps & {
		hideHeader?: boolean;
		label?: IBaseComponentProps;
		input?: IBaseComponentProps;
	};
	boxes?: IBaseComponentProps & {
		hideHeader?: boolean;
		defaultValue?: string[];
		label?: IBaseComponentProps;
		input?: IBaseComponentProps;
	};
}

export interface NSboxBooleansState
{
	values: string[];
}

export class NSBoxBooleans extends React.Component<NSBoxBooleansProps, NSboxBooleansState>
{
	lastValues: string | null = null;
	constructor(props: NSBoxBooleansProps)
	{
		super(props);
		this.state = {
			values: this.props.boxes?.defaultValue ?? []
		};
		this.getMarkAllValue = this.getMarkAllValue.bind(this);
		this.onMarkAllChecked = this.onMarkAllChecked.bind(this);
		this.onItemChecked = this.onItemChecked.bind(this);
		this.getValues = this.getValues.bind(this);
		this.setValues = this.setValues.bind(this);
		this.reverse = this.reverse.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	private getMarkAllValue(): boolean | null 
	{
		if (this.props.items.length === this.state.values.length)
			return true;
		if (this.state.values.length === 0)
			return false;
		return null;
	}

	private onMarkAllChecked(e: NSBoxBoolean): void
	{
		let current_value = e.getValueNull();
		if (current_value != null)
		{
			let tobe_value = this.getMarkAllValue();
			if (current_value !== tobe_value)
				if (current_value)
				{
					let values = this.state.values;
					if (this.state.values.length !== this.props.items.length)
					{
						values = this.props.items.map(item => item.value);
						this.setState({ values }, () =>
						{
							this.onChanged();
						});
					}
				}
				else
				{
					if (this.state.values.length !== 0)
						this.setState({ values: [] }, () =>
						{
							this.onChanged();
						});
				}
		}
	}

	private onItemChecked(e: NSBoxBoolean): void
	{
		let value = e.props.id ?? "";
		let values = this.state.values;
		let checked = e.getValue(false);
		if (checked)
		{
			if (!values.includes(value))
				values.push(value);
		}
		else
			values = values.filter(item => item !== value);
		this.setState({ values }, () =>
		{
			this.onChanged();
		});
	}

	private reverse(values: string[]): string[]
	{
		let all = this.props.items.map(item => item.value);
		return all.filter(item => !values.includes(item));
	}
	private onChanged(callback?: () => void)
	{
		let values = this.getValues().join(";");
		if (this.lastValues !== values)
		{
			this.lastValues = values;
			this.props.onChanged?.(this);
			callback?.();
		}
	}

	getValues(): string[]
	{
		if (this.props.reverse)
			return this.reverse(this.state.values);
		return this.state.values;
	}

	setValues(values: string[], callback?: () => void): void
	{
		if (!values)
			values = [];
		if (this.props.reverse)
			values = this.reverse(values);
		this.setState({ values }, () =>
		{
			this.onChanged(callback);
		});
	}

	override render()
	{
		return (
			<>
				<NSBoxBoolean
					id={this.props.box_all?.id}
					classList={this.props.box_all?.classList}
					style={{ maxWidth: "100%", width: "100%", ...this.props.box_all?.style }}
					label={this.props.box_all?.label}
					input={this.props.box_all?.input}
					title="All"
					required={false}
					hideHeader={this.props.box_all?.hideHeader}
					checked={this.getMarkAllValue()}
					onChanged={this.onMarkAllChecked}
				/>
				{
					this.props.items.map((e, index) =>
						<NSBoxBoolean
							key={`NSBoxBooleans_NSBoxBoolean_key_${index}`}
							id={e.value}
							classList={this.props.boxes?.classList}
							style={{ width: NSBox.width.one, ...this.props.boxes?.style }}
							label={this.props.boxes?.label}
							input={this.props.boxes?.input}
							title={e.text}
							required={true}
							hideHeader={this.props.boxes?.hideHeader}
							checked={this.state.values.includes(e.value)}
							defaultValue={this.props.boxes?.defaultValue?.includes(e.value)}
							onChanged={this.onItemChecked}
						/>
					)
				}
			</>
		);
	}
}